import React from 'react';
import Icon from '../Icon';
import './style.scss';

const MiniStats = ({ icon, title, textColor, iconColor, children }) => {
	return (
		<div className="icon-section">
			<Icon className="icon-section-icon" style={{ color: iconColor }}>
				{icon}
			</Icon>
			<div className="icon-section-info">
				<div className="icon-section-info-title" style={{ color: iconColor }}>
					{title}
				</div>
				<div className="icon-section-info-subtitle" style={{ color: textColor }}>
					{children}
				</div>
			</div>
		</div>
	);
};

export default MiniStats;
